// Tiny dev-only logger. In production builds these are no-ops so we don't leak
// internal state to the browser console. `error` still fires in production because
// a stack in the console is invaluable for any real issue that reaches a user.
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  // Errors always logged — but only to console; hook into Sentry etc. here later if needed.
  error: (...args) => { console.error(...args); },
};
